import { createContext, useContext } from 'react'

export type ErrorMessage = string

export type ErrorContextProps = {
  setError: (message: ErrorMessage) => void
  clearError: () => void
  error: string | undefined
}

const notFound = () => {
  throw new Error('ErrorContext.Provider not found')
}

export const ErrorContext = createContext<ErrorContextProps>({
  setError: notFound,
  clearError: notFound,
  error: undefined,
})

export const useErrorContext = () => {
  return useContext(ErrorContext)
}
